import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { ViewLayout } from '../layout/ViewLayout'
import { ViewPage } from '../ui/viewPage'

export const ViewRouter = observer(() => {
  return (
    <Routes>
      <Route element={<ViewLayout />}>
        <Route path={'/'} element={<ViewPage />} />
      </Route>
    </Routes>
  )
})
